<template>
   <div class="fullpage" v-bind:class="{ withopacity: hover }" id="sloganfullpage"  >
      <div v-if="currentlang=='it'"  class="headline" >
            <div>NEWLAB è un’<a :href="linkazienda" v-bind:class="{ normallink: !hoverazienda, activelink:hoverazienda }"    @mouseover="fnSetHoverAzienda(true)" @mouseleave="fnSetHoverAzienda(false)" @click="fnResetHover()" >azienda</a></div>
            <div>di progettazione elettronica,</div>
            <div>che offre <a :href="linkcasestudies" v-bind:class="{ normallink: !hoversoluzioni, activelink:hoversoluzioni }"  @mouseover="fnSetHoverSoluzioni(true)" @mouseleave="fnSetHoverSoluzioni(false)" @click="fnResetHover()" >soluzioni custom</a></div>
            <div>dall’<a :href="linkspiegazioni" v-bind:class="{ normallink: !hoverideazione, activelink:hoverideazione }"  @mouseover="fnSetHoverIdeazione(true)" @mouseleave="fnSetHoverIdeazione(false)" @click="fnResetHover()" >ideazione</a> alla fornitura.</div>
      </div>
      
      <div v-if="currentlang=='en'" class="headline" >
            <div>NEWLAB is an</div>
            <div>electronic design <a :href="linkazienda"  v-bind:class="{ normallink: !hoverazienda, activelink:hoverazienda }"    @mouseover="fnSetHoverAzienda(true)" @mouseleave="fnSetHoverAzienda(false)" @click="fnResetHover()" >company</a></div>
            <div>that offers <a :href="linkcasestudies" v-bind:class="{ normallink: !hoversoluzioni, activelink:hoversoluzioni }"  @mouseover="fnSetHoverSoluzioni(true)" @mouseleave="fnSetHoverSoluzioni(false)" @click="fnResetHover()" >custom solutions</a></div>
            <div>from <a :href="linkspiegazioni" v-bind:class="{ normallink: !hoverideazione, activelink:hoverideazione }"  @mouseover="fnSetHoverIdeazione(true)" @mouseleave="fnSetHoverIdeazione(false)" @click="fnResetHover()" >concept</a> to supply.</div>
      </div>



      <div class="arrow_down"><a :href="linkspiegazioni"><img src="@/assets/images/arrow_down_white.svg"></a></div>

   </div> 
   
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"



export default {
  name: "cmpsloganfullpage",
  mixins:[multilangmixin],
  props:["linkspiegazioni"],
  
  data(){
      return {

              "hoverazienda":false,
              "hoversoluzioni":false,
              "hoverideazione":false,
              
            };
  },


  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

  },

  computed:{
      
      hover(){
        return this.hoverazienda || this.hoversoluzioni || this.hoverideazione;        
      },

      linkazienda()
      {
        return "/"+this.currentlang+"/contatti";
      },
 
      linkcasestudies()
      {
        return "/"+this.currentlang+"/casestudies";
      }

  },


  methods:{


      fnResetHover()
      {
        this.hoverazienda=false;
        this.hoversoluzioni=false;
        this.hoverideazione=false;

      },


      fnSetHoverAzienda(piflag)
      {
        this.hoverazienda=piflag;
      },

      fnSetHoverSoluzioni(piflag)
      {
        this.hoversoluzioni=piflag;
      },

      fnSetHoverIdeazione(piflag)
      {
        this.hoverideazione=piflag;
      }


  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    

 .fullpage{

   background-color: #ffdd00;
   width: 100vw;
   height: 94vh;
   transition: 0.7s;
   color: black;
   position: relative;
   /* margin-top: 20vh;*/
 }

 
 .withopacity{
   color: #00000025;
   transition: 0.7s;

 }


.sottolineato{

    
    text-decoration: underline;
    text-decoration-style: solid;
    /*text-decoration-color: #ffdd00;*/
    
    text-decoration-thickness: 0.1em;    
    /* line-height: 7vh; */
    /* text-underline-offset: 1vh;*/


}
     




.activelink
{
    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    

}
 
.activelink:visited{

  color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.activelink:active{

  color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.activelink:hover{

    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}






.normallink
{
    color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    

}
 
.normallink:visited{

  color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.normallink:active{

  color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.normallink:hover{

    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

 


  @media screen and (min-width: 600px)    {
      /*  schermo desktop */
    
  .headline
      {
        
        margin-left: auto;
        margin-right: auto;
        
        max-width: 60%;
        min-height: 200px;
        font-weight: 800;
        font-size: 3vw;
        /*padding-top: 30px;
        padding-left: 80px;
        */
        border-width: 0px;
        padding-top: 27vh;   


       

      }
    


      .arrow_down{
        position: absolute;
        right: 5vh;
        bottom: 5vh;
        
      }


      


  }
  
  @media screen and (max-width: 600px) {
     /*  schermo mobile */
  

  
    .headline
    {
      max-width: 80%;
       margin-left: auto;
        margin-right: auto;
      /*padding-top: 30px;
      padding-left: 20px;*/
        padding-top: 20vh;    
      
      min-height: 200px;
      font-weight: 800;
      
      font-size: 5vw;

      line-height: 3.5vh;

     

    }




    .arrow_down{
      position: absolute;
      right: 5vh;
      bottom: 20vh;
      
    }


    .arrow_down a img{
        width: 10vw;    
    }

  }


</style>
